import {useCallback} from 'react';
import {useStore, useSelector} from 'react-redux';

import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {hotelReviewActions} from '@ibibo/hotels-review-reducer';
import {hotelsPartnerFn} from '../pages/common/redux/selectors';
import makeReviewPageUrl from '../utils/makeReviewPageUrl';

export default function useNavigateToReviewPage() {
    const store = useStore();
  const history = useHistory();
  const dispatch = useDispatch();
  const partner = useSelector(hotelsPartnerFn);
  const updateReviewPageInput = useCallback(
    data => {
      return dispatch(hotelReviewActions.updateDescblockInput(data));
    },
    [dispatch],
  );

  // const updateCommonReducer = useCallback((data) => {
  //   return dispatch(updateQueryAction(data));
  // },[dispatch]);

  const navigator = (urlParams, descBlockInput) => {
    const {common} = store.getState();
    const {country} = common;
    // const {srp, common} = store.getState();
    // const {checkout, checkin, roomString, destination} = common;
    // const {srpConfig, srpData} = srp;
    // const {filter} = srpConfig;
    // const {cityMetaInfo} = srpData;
    // const {cityCode, hotelName} = urlParams;
    // if(cityCode && hotelName){
    // const destination = {_id: cityCode,n: hotelName, t: "hotel"}
    // updateCommonReducer({destination});
    // }
    updateReviewPageInput(descBlockInput);
    history.push(makeReviewPageUrl({...urlParams, cc: country}, partner));
  };

  return [navigator];
}
